import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { OriginState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): OriginState => state.origin);

export default selectors;
